<template>
  <footer>
    <div class="space-between">
      <router-link :to="{name: 'home'}">
        <svg class="main-logo-shadow" width="140" height="24" viewBox="0 0 140 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M5.15501 4.08439H0V4.84388L8.99129 24H11.2691L20.1705 4.84388V4.08439H15.0155L10.2201 15.2236H10.0702L5.15501 4.08439Z"
              fill="url(#paint0_linear)"/>
          <path
              d="M28.931 19.3587V8.47257H31.3886C31.3886 6.78481 31.3886 5.74402 31.3886 4.08439C27.9719 4.08439 24.5852 4.08439 21.1685 4.08439C21.1685 5.74402 21.1685 6.78481 21.1685 8.47257H23.6261V19.3587H20.9587C20.9587 21.0183 20.9587 22.2841 20.9587 24C24.5253 24 28.0319 24 31.5984 24C31.5984 22.2841 31.5984 21.0183 31.5984 19.3587H28.931Z"
              fill="url(#paint1_linear)"/>
          <path
              d="M49.4071 24H51.3253V4.08439C49.4971 4.08439 47.6688 4.08439 45.8406 4.08439V13.7328L35.2309 4H33.2828V24C35.111 24 36.9692 24 38.8274 24V14.0985L49.4071 24Z"
              fill="url(#paint2_linear)"/>
          <path
              d="M66.7303 4.08439C61.815 4.08439 58.4882 4.08439 53.633 4.08439C53.633 10.6104 53.633 17.4177 53.633 24C58.4882 24 62.0848 24 67 24C67 22.5091 67 20.7651 67 19.3024C63.853 19.3024 62.0548 19.3024 58.9678 19.3024C58.9678 18.121 58.9678 16.9958 58.9678 15.8425H66.1009C66.1009 14.3516 66.1009 12.8608 66.1009 11.3699H58.9678V8.58509C62.0548 8.58509 63.6133 8.58509 66.7303 8.58509C66.7303 7.0661 66.7303 5.54712 66.7303 4.08439Z"
              fill="url(#paint3_linear)"/>
          <g filter="url(#filter0_i)">
            <path
                d="M5.15501 2.08439H0V2.84388L8.99129 22H11.2691L20.1705 2.84388V2.08439H15.0155L10.2201 13.2236H10.0702L5.15501 2.08439Z"
                fill="url(#paint4_linear)"/>
            <path
                d="M28.931 17.3587V6.47257H31.3886C31.3886 4.78481 31.3886 3.74402 31.3886 2.08439C27.9719 2.08439 24.5852 2.08439 21.1685 2.08439C21.1685 3.74402 21.1685 4.78481 21.1685 6.47257H23.6261V17.3587H20.9587C20.9587 19.0183 20.9587 20.2841 20.9587 22C24.5253 22 28.0319 22 31.5984 22C31.5984 20.2841 31.5984 19.0183 31.5984 17.3587H28.931Z"
                fill="url(#paint5_linear)"/>
            <path
                d="M49.4071 22H51.3253V2.08439C49.4971 2.08439 47.6688 2.08439 45.8406 2.08439V11.7328L35.2309 2H33.2828V22C35.111 22 36.9692 22 38.8274 22V12.0985L49.4071 22Z"
                fill="url(#paint6_linear)"/>
            <path
                d="M66.7303 2.08439C61.815 2.08439 58.4882 2.08439 53.633 2.08439C53.633 8.61041 53.633 15.4177 53.633 22C58.4882 22 62.0848 22 67 22C67 20.5091 67 18.7651 67 17.3024C63.853 17.3024 62.0548 17.3024 58.9678 17.3024C58.9678 16.121 58.9678 14.9958 58.9678 13.8425H66.1009C66.1009 12.3516 66.1009 10.8608 66.1009 9.3699H58.9678V6.58509C62.0548 6.58509 63.6133 6.58509 66.7303 6.58509C66.7303 5.0661 66.7303 3.54712 66.7303 2.08439Z"
                fill="url(#paint7_linear)"/>
          </g>
          <path
              d="M79.4329 12.6648L71.0252 4.02841H69V23.9716C70.8718 23.9716 72.7436 23.9716 74.6153 23.9716V15.108L79.1567 19.5398H79.7704L84.3425 15.108V23.9716C86.2142 23.9716 88.086 23.9716 89.9578 23.9716V4.02841H87.994L79.4329 12.6648Z"
              fill="url(#paint8_linear)"/>
          <path
              d="M99.8307 19.5114V8.51705H102.347C102.347 6.8125 102.347 5.76136 102.347 4.08523C98.8488 4.08523 95.3814 4.08523 91.8833 4.08523C91.8833 5.76136 91.8833 6.8125 91.8833 8.51705H94.3995V19.5114H91.6685C91.6685 21.1875 91.6685 22.2386 91.6685 23.9716C95.32 23.9716 98.9102 23.9716 102.562 23.9716C102.562 22.2386 102.562 21.1875 102.562 19.5114H99.8307Z"
              fill="url(#paint9_linear)"/>
          <path
              d="M120.988 24H122.952V4.08523C121.08 4.08523 119.208 4.08523 117.337 4.08523V13.8295L106.474 4H104.48V23.9716C106.351 23.9716 108.254 23.9716 110.156 23.9716V14.1989L120.988 24Z"
              fill="url(#paint10_linear)"/>
          <path
              d="M138.724 4.08523C133.692 4.08523 130.285 4.08523 125.315 4.08523C125.315 10.6761 125.315 17.3239 125.315 23.9716C130.285 23.9716 133.968 23.9716 139 23.9716C139 22.4659 139 20.9318 139 19.4545C135.778 19.4545 133.937 19.4545 130.776 19.4545C130.776 18.2614 130.776 17.125 130.776 15.9602H138.079C138.079 14.4545 138.079 12.9489 138.079 11.4432H130.776V8.63068C133.937 8.63068 135.533 8.63068 138.724 8.63068C138.724 7.09659 138.724 5.5625 138.724 4.08523Z"
              fill="url(#paint11_linear)"/>
          <g filter="url(#filter1_i)">
            <path
                d="M79.4329 10.6648L71.0252 2.02841H69V21.9716C70.8718 21.9716 72.7436 21.9716 74.6153 21.9716V13.108L79.1567 17.5398H79.7704L84.3425 13.108V21.9716C86.2142 21.9716 88.086 21.9716 89.9578 21.9716V2.02841H87.994L79.4329 10.6648Z"
                fill="url(#paint12_linear)"/>
            <path
                d="M99.8307 17.5114V6.51705H102.347C102.347 4.8125 102.347 3.76136 102.347 2.08523C98.8488 2.08523 95.3814 2.08523 91.8833 2.08523C91.8833 3.76136 91.8833 4.8125 91.8833 6.51705H94.3995V17.5114H91.6685C91.6685 19.1875 91.6685 20.2386 91.6685 21.9716C95.32 21.9716 98.9102 21.9716 102.562 21.9716C102.562 20.2386 102.562 19.1875 102.562 17.5114H99.8307Z"
                fill="url(#paint13_linear)"/>
            <path
                d="M120.988 22H122.952V2.08523C121.08 2.08523 119.208 2.08523 117.337 2.08523V11.8295L106.474 2H104.48V21.9716C106.351 21.9716 108.254 21.9716 110.156 21.9716V12.1989L120.988 22Z"
                fill="url(#paint14_linear)"/>
            <path
                d="M138.724 2.08523C133.692 2.08523 130.285 2.08523 125.315 2.08523C125.315 8.67614 125.315 15.3239 125.315 21.9716C130.285 21.9716 133.968 21.9716 139 21.9716C139 20.4659 139 18.9318 139 17.4545C135.778 17.4545 133.937 17.4545 130.776 17.4545C130.776 16.2614 130.776 15.125 130.776 13.9602H138.079C138.079 12.4545 138.079 10.9489 138.079 9.44318H130.776V6.63068C133.937 6.63068 135.533 6.63068 138.724 6.63068C138.724 5.09659 138.724 3.5625 138.724 2.08523Z"
                fill="url(#paint15_linear)"/>
          </g>
          <defs>
            <filter id="filter0_i" x="0" y="1" width="67" height="21" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                             result="hardAlpha"/>
              <feOffset dy="-1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"/>
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
            </filter>
            <filter id="filter1_i" x="69" y="1" width="70" height="21" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                             result="hardAlpha"/>
              <feOffset dy="-1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"/>
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
            </filter>
            <linearGradient id="paint0_linear" x1="33.5" y1="4" x2="33.5" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint1_linear" x1="33.5" y1="4" x2="33.5" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint2_linear" x1="33.5" y1="4" x2="33.5" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint3_linear" x1="33.5" y1="4" x2="33.5" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint4_linear" x1="33.5" y1="2" x2="33.5" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint5_linear" x1="33.5" y1="2" x2="33.5" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint6_linear" x1="33.5" y1="2" x2="33.5" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint7_linear" x1="33.5" y1="2" x2="33.5" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint8_linear" x1="104" y1="4" x2="104" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint9_linear" x1="104" y1="4" x2="104" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint10_linear" x1="104" y1="4" x2="104" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint11_linear" x1="104" y1="4" x2="104" y2="24" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2870A0"/>
              <stop offset="1" stop-color="#144F77"/>
            </linearGradient>
            <linearGradient id="paint12_linear" x1="104" y1="2" x2="104" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint13_linear" x1="104" y1="2" x2="104" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint14_linear" x1="104" y1="2" x2="104" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
            <linearGradient id="paint15_linear" x1="104" y1="2" x2="104" y2="22" gradientUnits="userSpaceOnUse">
              <stop stop-color="#58D7FF"/>
              <stop offset="1" stop-color="#18ACFF"/>
            </linearGradient>
          </defs>
        </svg>
      </router-link>
      <div class="line pc-hide"></div>
      <div class="contacts space-between">
        <ul>
          <li>
            <a href="#" class="svg-wrapper">
              <svg>
                <g>
                  <path
                      d="M4.88721 1.8562C3.29519 1.8562 2 3.22946 2 4.91741C2 6.60536 3.29519 7.97862 4.88721 7.97862C6.47923 7.97862 7.77445 6.60536 7.77445 4.91741C7.77445 3.22946 6.47927 1.8562 4.88721 1.8562Z"/>
                  <path
                      d="M11.6017 2C11.5948 2 11.5878 2.00003 11.5809 2.00007C10.876 2.0059 10.2175 2.30354 9.72688 2.83823C9.24484 3.36347 8.98273 4.05639 8.98876 4.7893C8.99482 5.52222 9.26834 6.2107 9.75896 6.72795C10.2535 7.24921 10.9085 7.53548 11.6056 7.53548C11.6126 7.53548 11.6196 7.53545 11.6267 7.53541C12.3316 7.52958 12.9901 7.2319 13.4807 6.69724C13.9628 6.17201 14.2249 5.47909 14.2189 4.74614C14.2063 3.22731 13.0343 2 11.6017 2Z"/>
                  <path
                      d="M11.6169 8H11.3744C10.245 8 9.21437 8.4846 8.43625 9.27886C8.63094 9.44745 8.81625 9.6312 8.99187 9.82941C9.51 10.4142 9.91687 11.0956 10.2012 11.8546C10.4575 12.5381 10.6037 13.2583 10.6378 14H16V12.9465C16 10.2191 14.0337 8 11.6169 8Z"/>
                  <path
                      d="M9.69844 14.0253C9.61 12.4023 8.88781 10.9747 7.81 10.0598C7.02594 9.39409 6.05344 9 5 9H4.70813C2.10781 9.00004 0 11.4012 0 14.3635V15H9.70781V14.3635C9.70781 14.2499 9.70469 14.1371 9.69844 14.0253Z"/>
                </g>
              </svg>
              <a href="https://vk.com/vinepe" target="_blank" class="linker">Группа ВКонтакте</a>
            </a>
          </li>
          <li>
            <a href="#" class="svg-wrapper">
              <svg>
                <path
                    d="M7.96875 0.5C3.57469 0.5 0 3.654 0 7.53125C0 9.16912 0.648188 10.7562 1.82784 12.0141C2.06131 12.9768 1.77794 13.9967 1.07481 14.6998C0.780813 14.9938 0.988719 15.5 1.40625 15.5C2.742 15.5 4.02969 14.9768 4.98641 14.0539C5.93306 14.3918 6.93466 14.5625 7.96875 14.5625C12.3628 14.5625 16 11.4085 16 7.53125C16 3.654 12.3628 0.5 7.96875 0.5ZM4.28125 8.9375C3.50581 8.9375 2.875 8.30669 2.875 7.53125C2.875 6.75581 3.50581 6.125 4.28125 6.125C5.05669 6.125 5.6875 6.75581 5.6875 7.53125C5.6875 8.30669 5.05669 8.9375 4.28125 8.9375ZM8.03125 8.9375C7.25581 8.9375 6.625 8.30669 6.625 7.53125C6.625 6.75581 7.25581 6.125 8.03125 6.125C8.80669 6.125 9.4375 6.75581 9.4375 7.53125C9.4375 8.30669 8.80669 8.9375 8.03125 8.9375ZM11.7812 8.9375C11.0058 8.9375 10.375 8.30669 10.375 7.53125C10.375 6.75581 11.0058 6.125 11.7812 6.125C12.5567 6.125 13.1875 6.75581 13.1875 7.53125C13.1875 8.30669 12.5567 8.9375 11.7812 8.9375Z"></path>
              </svg>
              <a href="http://vk.me/vinepe" target="_blank" class="linker">Техподдержка</a>
            </a>
          </li>
        </ul>
        <a href="https://phpmc.ru/" target="_blank" class="linker pc-only">сделано в PHPMC</a>
      </div>
    </div>
    <div class="line main-line"></div>
    <div class="company">
      <div>ИП Асафьев Дмитрий Денисович</div>
      <div>ИНН 780257559584</div>
      <div>ОГРН 319784700040575</div>
      <a href="/agreement.pdf" class="terms-of-use">Пользовательское соглашение</a>
      <a href="/privacy.pdf" class="terms-of-use">Конфиденциальность</a>
    </div>
      <div class="pay-types">
          <div class="type" v-for="type in payTypes">
              <img :src="getImgPay(type)" :alt="type">
          </div>
      </div>
    <div class="line pc-hide"></div>
    <a href="https://phpmc.ru/" target="_blank" class="phpmc linker pc-hide">сделано в PHPMC</a>
  </footer>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "footerBlock",
  data: () => ({
      payTypes: [
          'mir', 'visa', 'mastercard', 'qiwi', 'applePay', 'spay',
          'gpay', 'megafon', 'mts', 'tele2', 'wmr', 'wmz'
      ],
  }),
  computed: {
    ...mapGetters('window', ['pcVersion'])
  },
    methods: {
        getImgPay(type) {
            return require(`@/assets/icons/payment/${type}.svg`);
        }
    }
}
</script>

<style scoped lang="scss">
footer {
  position: absolute;
  bottom: 48px;
  left: 0;
  right: 0;
  padding: 0 16px;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  @include tablet {
    .space-between {
      flex-direction: column;
      align-items: flex-start !important;

      ul {
        flex-direction: column;

        li + li {
          margin-top: 16px;
        }
      }
    }
  }

  .main-logo-shadow {
    @include tablet {
      margin-bottom: 16px;
    }
  }

  .terms-of-use {
    cursor: pointer;
    color: $text_gray;
  }

  .space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .main-line {
    margin: 24px 0;

    @include tablet {
      margin: 0;
    }
  }

  .company {
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    justify-content: space-between;

    @include tablet {
      display: grid;
      justify-items: self-start;
      grid-template-columns: 1fr;
      grid-gap: 16px;
      padding: 16px 0;
      font-size: 16px;
      line-height: 19px;
    }

    a {
      border-bottom: 1px solid rgba(93, 105, 122, 0.12);
    }
  }

    .pay-types {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
        justify-items: center;
        margin-top: 20px;

        @include mobile {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            margin-bottom: 16px;
        }

        .type {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 75px;
            min-height: 28px;
            background: #1A1C1F;
            border-radius: 2px;
            margin-top: 4px;

            @include tablet {
                min-width: 42px;
                min-height: 24px;

                img {
                    max-height: 16px;
                    max-width: 30px;
                }
            }
        }
    }

  .contacts {
    min-height: 24px;
    margin-left: 110px;

    @include tablet {
      margin-left: 0;
      padding: 16px 0;
    }

    ul {
      display: flex;

      li a {
        display: flex;
        align-items: center;
        margin-right: 40px;

        svg {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }

        &:hover .linker {
          border-bottom: solid 1px rgba($blue, 0.64);
        }
      }
    }
  }
  .phpmc.linker {
    color: $text_gray !important;
    margin-top: 16px;
  }
}
</style>
